import { render, staticRenderFns } from "./BasicDetailsPage.vue?vue&type=template&id=4aea35fe&scoped=true"
import script from "./BasicDetailsPage.vue?vue&type=script&lang=js"
export * from "./BasicDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./BasicDetailsPage.vue?vue&type=style&index=0&id=4aea35fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aea35fe",
  null
  
)

export default component.exports